import { IConfig } from '@cian/config/shared';
import { ErrorLogComponent } from '@cian/error-log-component';
import { ILogger } from '@cian/logger/shared';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Provider } from 'react-redux';
import { TReduxStore } from '../../types/redux';
import { Page } from '../Page';

/**
 * Импорт картинки для meta:og тегов
 *
 * Нужен чтобы картинка появилась в dist/assets при сборке, и попала
 * на cdn при деплое микросервиса, используется в src/node/services/buildPage/service.ts
 */
import '../../static/meta.jpg';

export interface IApplicationContext {
  config: IConfig;
  logger: ILogger;
}

export interface IApplicationProps extends IApplicationContext {
  reduxStore: TReduxStore;
}

export type TApplicationСontextTypes = {
  [K in keyof IApplicationContext]: PropTypes.Requireable<IApplicationContext[K]>;
};

export class Application extends React.Component<IApplicationProps> {
  // TODO: переделать на React Context API
  public static childContextTypes: TApplicationСontextTypes = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    config: PropTypes.object as any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    logger: PropTypes.object as any,
  };

  public constructor(props: IApplicationProps) {
    super(props);
  }

  // TODO: переделать на React Context API
  public getChildContext(): IApplicationContext {
    return {
      config: this.props.config,
      logger: this.props.logger,
    };
  }

  public render() {
    const { logger, reduxStore } = this.props;

    return (
      <ErrorLogComponent logger={logger}>
        <Provider store={reduxStore}>
          <Page />
        </Provider>
      </ErrorLogComponent>
    );
  }
}
